/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/fullpaymentreport.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {
  GET_DISCOUNT_REPORT,
  GET_DISCOUNT_REPORT_ADMIN,
  GET_PRESENTATIONS,
} from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment";
import { pretty } from "@vlinder-web/utils-react";
import { StorageModule } from "@vlinder-web/storage-module-react";
import jwt_decode from "jwt-decode";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetDiscountReportMethods extends IPluginMethodMap {
  getDiscountReport(args: any): Promise<any>;
}

export class GetDiscountReportService implements IAgentPlugin {
  readonly methods: IGetDiscountReportMethods;

  constructor() {
    this.methods = {
      getDiscountReport: this.getDiscountReport.bind(this),
    };
  }

  async getDiscountReport(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let filer_apply = args?.criteria ? args?.criteria : {};
    console.log("filet apply====", filer_apply);

    filer_apply = this.convertCriteria(args?.criteria);
    let presentationOptions: any = [],
      defaultPresentation: any = "";
    let variables = {
      options: {
        limit: args?.size ?? 10,
        skip: args?.offset ?? 0,
        sort: {
          field: "box.createdAt",
          order: "desc",
        },
      },
      filter: {
        ...filer_apply,
      },
    };
    const _filter = {
      // status: {
      //   eq: "active",
      // },
      // year: {
      //   eq: "2024",
      // },
    };
    try {
      if (client) {
        const presentation = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: _filter,
            options: {
              limit: 10,
              skip: 0,
              sort: {
                field: "status",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        if (
          presentation &&
          presentation?.data?.getPresentations?.content[0]?.id
        ) {
          defaultPresentation =
            presentation?.data?.getPresentations?.content[0]?.id;
          presentationOptions =
            presentation?.data?.getPresentations?.content?.map((_item: any) => {
              return { value: _item?.id, label: _item?.name };
            });
          variables.filter.presentation = {
            eq: args?.criteria?.presentation ?? defaultPresentation,
          };
        }
        const storageSrv = StorageModule.getInstance();
        let _sessionToken = storageSrv.get(
          "userProfile",
          "session"
        )?.accessToken;
        let _localToken = storageSrv.get("userProfile", "local")?.accessToken;
        let _token = _localToken ?? _sessionToken;
        const tokenRole = jwt_decode(_token);
        const res = await client.query({
          query:
            tokenRole?.currentRole?.name === "production"
              ? GET_DISCOUNT_REPORT
              : GET_DISCOUNT_REPORT_ADMIN,
          variables: variables,
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          let _rowData = this.formatTable(
            res?.data?.getDiscountBoxesSearch?.content
          );

          let _totalPages = res?.data?.getDiscountBoxesSearch?.count
            ? Math.ceil(parseInt(res?.data?.getDiscountBoxesSearch?.count) / 10)
            : 1;

          let _currentPage =
            res?.data?.getDiscountBoxesSearch?.skip /
              res?.data?.getDiscountBoxesSearch?.limit +
            1;
          console.log(
            "_rowData==>",
            pretty(res?.data?.getDiscountBoxesSearch?.content[1])
          );
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getDiscountBoxesSearch?.content?.length <= 0,
            activePage: _currentPage,
            currentPage: _currentPage,
            pageSize: _rowData.length,
            totalCount: res?.data?.getDiscountBoxesSearch?.count,
            totalPages: _totalPages,
            searchPresentationFilter: presentationOptions,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private convertCriteria(criteria: any) {
    const result: any = {};
    for (const key in criteria) {
      if (key != "presentation") result[key] = { contains: criteria[key] };
    }
    return result;
  }

  private formatTable(users: any[]): any {
    let _rowData: any = [];
    users &&
      users.forEach((data?: any) => {
        _rowData.push({
          id: data?._id ?? "-",
          name: data?.discountDetails?.masqfullName ?? "Null Null",
          email: data?.box?.user?.email ?? "-",
          userId: data?.box?.user?.id ?? "-",
          Committee: data?.discountDetails?.invitedByfullName ?? "-",
          dateCreated: data?.box?.createdAt
            ? moment(data?.box?.createdAt).format("L")
            : "",
          costumeCost: data?.box?.totalAmount,
          dicountedCost: data?.totalDiscountedAmount,
          discountType: data?.discountType,
          toBePaid:
            data?.remainingAmount && data?.remainingAmount > 0
              ? data?.remainingAmount
              : 0,

          cosId: data?.box?.costumeID ?? "-",
          masqId: data?.box?.user?.vuid ?? "-",
          TypeName: data?.discountDetails?.sectionOptName,
          SectionName: data?.discountDetails?.sectionName,
          // totalpaidTTd: data?.totalAmount,
        });
      });
    return _rowData;
  }
}
